import React from 'react';
import './Navbar.css';

const Navbar = () => {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <div className="logo">
            <div className="logo-icon-container">
              <div className="logo-icon">
                <div className="storm-eye">🌀</div>
                <div className="ai-pulse">⚡</div>
              </div>
            </div>
            <div className="logo-content">
              <div className="logo-main">
                <span className="melissa-text">MELISSA</span>
              </div>
              <div className="logo-sub">
                <span className="ai-text">AI EMERGENCY RESPONSE</span>
              </div>
            </div>
          </div>
          <div className="nav-links">
            <a href="#climate-data" onClick={(e) => scrollToSection(e, 'climate-data')}>Dashboard</a>
            <a href="#damage-map" onClick={(e) => scrollToSection(e, 'damage-map')}>Damage Map</a>
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</a>
            <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
